module.exports = __webpack_public_path__ + "img/check.914b2dd8.svg";